import { render } from "./MyValidation.vue?vue&type=template&id=1a50af74&scoped=true"
import script from "./MyValidation.vue?vue&type=script&lang=js"
export * from "./MyValidation.vue?vue&type=script&lang=js"

import "./MyValidation.vue?vue&type=style&index=0&id=1a50af74&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a50af74"]])

export default __exports__